<template>
  <nav class="custom-navbar navbar navbar-default navbar-expand-md">
    <router-link
      to="/"
      class="navbar-brand router-link-exact-active router-link-active"
      @click.native="openMenu(null)"
    >
      <img src="/favicon.png" alt="Candlely">
    </router-link>

    <button
      type="button"
      aria-label="Toggle navigation"
      class="navbar-toggler collapsed"
      aria-expanded="false"
      aria-controls="nav-collapse"
      style="overflow-anchor: none;"
      @click="toggleMobile()"
    >
      <i class="fas fa-bars"></i>
    </button>

    <div id="nav-collapse" class="navbar-collapse collapse" :class="{ 'show': showMobile }">
      <ul class="navbar-nav">
        <li
          v-for="navigationItem in navigationList"
          :key="navigationItem.title"
          class="nav-item b-nav-dropdown dropdown"
          :class="{
            'router-link-active-parent': isMenuActive(navigationItem),
            'show': navigationItem.isOpen,
          }"
        >
          <a
            target="_self"
            href="#"
            role="button"
            class="nav-link dropdown-toggle"
            @click.prevent="openMenu(navigationItem)"
            @mouseenter="openMenuDelayed(navigationItem)"
            @mouseleave="cancelMenuDelayed()"
          >
            {{ navigationItem.title }}
          </a>

          <ul
          tabindex="-1"
          :class="[
            'dropdown-menu',
            navigationItem.isOpen ? 'show' : ''
          ]"
          >
            <template v-if="navigationItem.children">
              <template
                v-for="navigationChild in navigationItem.children"
                >
                <li
                  class="nav-item"
                  v-if="checkPermission(navigationChild)"
                  :key="`${navigationItem.title}_${navigationChild.title}`"
                >
                  <router-link
                    target="_self"
                    :to="navigationChild.path"
                    tabindex="-1"
                    class="nav-link"
                    :class="{
                      'disabled': navigationChild.disabled,
                    }"
                    :disabled="navigationChild.disabled"
                  >
                    <span>{{ navigationChild.title }}</span>
                  </router-link>
                </li>
              </template>
            </template>
          </ul>
        </li>
      </ul>

      <ul class="navbar-nav ml-auto">
        <li class="nav-item b-nav-dropdown dropdown"
          :class="{
            'show': accountMenu.isOpen,
          }"
        >
          <a
            target="_self"
            href="#"
            role="button"
            class="nav-link dropdown-toggle"
            @click.prevent="openMenu(accountMenu)"
            @mouseenter="openMenuDelayed(accountMenu)"
            @mouseleave="cancelMenuDelayed()"
          >
            <span>{{ accountLogin ?? 'Not logged in' }}</span>
          </a>
          <ul
            tabindex="-1"
            :class="[
            'dropdown-menu',
            'dropdown-menu-right',
            accountMenu.isOpen ? 'show' : ''
          ]"
          >
            <li v-if="isAdmin()" class="nav-item">
              <router-link
                class="nav-link"
                to="/developer"
              >
                Developer
              </router-link>
            </li>

            <li v-if="isAdmin()" class="nav-item">
              <router-link
                class="nav-link"
                to="/admin"
              >
              Admin
            </router-link>
            </li>

            <li v-if="isLogged()" class="nav-item">
              <router-link
                class="nav-link"
                to="/signout"
              >
                Sign out
              </router-link>
            </li>
            <li v-else class="nav-item">
              <router-link
                class="nav-link"
                to="/signin"
              >
                Sign in
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import navigationList from './NavigationList';

export default {
  name: 'NavigationCustom',
  components: {},
  computed: {
    accountLogin() {
      return this.account?.login;
    },
  },
  data() {
    return {
      account: this.$store.state.account,
      navigationList: navigationList.map((item) => ({
        ...item,
        isOpen: this.isMenuActive(item),
      })),
      accountMenu: {
        children: [
          { path: '/admin' },
          { path: '/developer' },
          { path: '/signout' },
          { path: '/signin' },
        ],
        isOpen: false,
      },
      dropdownChanger: {
        delay: 250,
        menu: null,
        timer: null,
      },
      showMobile: false,
    };
  },
  methods: {
    checkPermission(menu) {
      if (menu?.permission === undefined) return true;
      return this.hasPermission(menu.permission);
    },
    isMenuActive(menu) {
      const currentPath = this.$route.path;
      if (currentPath === '/') {
        return false;
      }
      if (menu?.path?.includes(currentPath)) {
        return true;
      }
      if (menu?.children && menu.children.some((child) => this.isMenuActive(child))) {
        return true;
      }
      return false;
    },
    openMenu(menu) {
      this.cancelMenuDelayed();
      this.navigationList.forEach((navigationItem) => {
        navigationItem.isOpen = false;
      });
      this.accountMenu.isOpen = false;
      if (menu) {
        menu.isOpen = true;
      }
    },
    openMenuDelayed(menu) {
      this.dropdownChanger.menu = menu;
      this.dropdownChanger.timer = setTimeout(() => {
        this.openMenu(menu);
      }, this.dropdownChanger.delay);
    },
    cancelMenuDelayed() {
      clearTimeout(this.dropdownChanger.timer);
      this.dropdownChanger.timer = null;
    },
    toggleMobile() {
      this.showMobile = !this.showMobile;
    },
  },
  created() {
    if (this.isMenuActive(this.accountMenu)) {
      this.openMenu(this.accountMenu);
    }
  },
};
</script>

<style lang="scss">
@media (min-width: 768px) {
  .custom-navbar {
    padding: 8px 36px;
    margin-bottom: 2rem;

    .navbar-header {
      width: 100%;
    }

    .b-nav-dropdown {
      & .dropdown-menu-right {
        left: -8px !important;
      }

      & .dropdown-toggle::after {
        vertical-align: middle;
      }
    }

    .navbar-nav .router-link-active {
      font-weight: bold;
    }

    .dropdown-menu.show {
      display: flex;
      gap: 8px;
    }

    .dropdown-menu-right {
      justify-content: end;
    }
  }
}
</style>
